import { Box, Typography } from "@material-ui/core";
import React from 'react'

export const SettingsRow = ({title, children, maxRows}) => (
  <Box
      style={{
      display: "flex",
      alignItems: "flex-start",
      padding: "8px 0",
      borderBottom: "1px solid #eee",
    }}
  >
    <Typography
      variant="body2"
      style={{
        color: "#999",
        minWidth: 80,
        fontSize: 12,
        textTransform: "uppercase",
        lineHeight: "20px",
        marginTop: 1,
      }}
    >
      {title}
    </Typography>
    <Box
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 120px)",
        gridTemplateRows: maxRows ? `repeat(${maxRows}, auto)` : undefined,
        gridAutoFlow: maxRows ? "column" : undefined,
        gap: "2px 0",
      }}
    >
      {children}
    </Box>
  </Box>
  

)